export const formConsumerGoSearchFields = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  METERING_POINT_ID: 'measurementPointId',
  CONSUMPTION_USAGE_ID: 'consumptionUsage',
};
